import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-451acf71"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_GlobalModal = _resolveComponent("GlobalModal")!
  const _component_GlobalToastMessage = _resolveComponent("GlobalToastMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_ctx.isOverlayOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "globalOverlay",
          class: _normalizeClass(`tw-fixed tw-w-full tw-h-screen tw-z-[3] tw-left-0 tw-top-0 overlay ${
        _ctx.overlayLanding ? 'screen-overlay' : ''
      }`),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMenu && _ctx.closeMenu(...args)))
        }, null, 2))
      : _createCommentVNode("", true),
    _createVNode(_component_GlobalModal),
    _createVNode(_component_GlobalToastMessage)
  ]))
}